import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
const google = (props) => (
  <SvgIcon
    width="17.363"
    height="13.027"
    viewBox="0 0 17.363 13.027"
    {...props}
  >
    <g transform="translate(-86.35 -284.527)">
      <text
        style={{
          stroke: "none",
          fontSize: "9px",
          fontFamily: "Roboto",
          fontWeight: 700,
        }}
        transform="translate(90.146 294)"
      >
        <tspan x="0" y="0">
          C
        </tspan>
      </text>
      <g transform="translate(87 285.177)">
        <path
          style={{ fill: "none", strokeWidth: "1.3px" }}
          d="M15.255,5.7A1.67,1.67,0,0,0,13.89,5l-9.214.008A1.673,1.673,0,0,0,3,6.675v8.377a1.673,1.673,0,0,0,1.675,1.667l9.214.008a1.67,1.67,0,0,0,1.365-.7l3.661-5.16L15.255,5.7Z"
          transform="translate(-3 -5)"
        />
      </g>
    </g>
  </SvgIcon>
);
export default google;



// WEBPACK FOOTER //
// ./src/common/icons/Task/index.tsx